import Red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: blue,
    secondary: Red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background:{
      default: '#F8F9FD',
    } 
  },
  overrides: {
    MuiCardActions: {
      root: {
        justifyContent:"flex-end"
      }
    },
    MuiPaper: {
      elevation4: {
        boxShadow: '0 2px 12px 0 rgba(0,0,0,0.12)'
      }
    },
  },
  cardContent: {
    textAlign: "right"
  },
  tools: {
    textAlign: 'right'
  },
  form: {
    backgroundColor: grey[200]
  },
  card: {
    marginBottom: 8,
    borderRadius: 12,
  },
  typography: {
    useNextVariants: true,
  },
});


// WEBPACK FOOTER //
// ./src/theme.js